/* ===================================================================
   泰好批店 taihopai.shop 2026-10-05
   給「自繪商品卡」用的加入購物車（搭配 snippets/lgw-atc-button.liquid）

   為什麼要自己寫：
     第三方 section ss-featured-collection-tabs-2 自己刻了商品卡，不是主題的
     product-card，所以主題內建 quick buy 不會出現在那裡。這裡用最標準的
     Cart AJAX API 處理，不動主題任何既有行為。

   安全性：
     - 只攔截帶 data-lgw-atc 的按鈕（＝我們自己 render 的），不影響主題任何按鈕
     - document 事件委派，section 換分類頁籤後照樣有效
     - 重複載入無害（window.__lgwAtcInit 守衛）
   =================================================================== */
(function () {
  if (window.__lgwAtcInit) return;
  window.__lgwAtcInit = true;

  var ADDING_TEXT = '加入中…';
  var ADDED_TEXT = '已加入 ✓';
  var FAIL_TEXT = '加入失敗，請重試';

  function setLabel(btn, text) {
    var label = btn.querySelector('.lgw-atc__label');
    if (label) label.textContent = text;
  }

  function currentLabel(btn) {
    var label = btn.querySelector('.lgw-atc__label');
    return label ? label.textContent : '';
  }

  /* 更新頁首購物車數量
     泰好批的 Enterprise 主題：#cart-icon-bubble > .header__cart-count > .header__cart-count-number
     而且「沒東西時整個 .header__cart-count 不存在」→ 需要時要自己建出來。 */
  function updateHeaderCartCount(count) {
    var bubble = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__cart-count');
    if (!bubble) return;

    if (!bubble.querySelector('.header__cart-count')) {
      // 購物車本來是空的：照主題的結構把數量泡泡建出來
      var box = document.createElement('div');
      box.className = 'header__cart-count absolute bg-theme-text text-theme-bg text-center';
      var num = document.createElement('span');
      num.className = 'header__cart-count-number';
      num.setAttribute('aria-hidden', 'true');
      num.textContent = count;
      box.appendChild(num);
      bubble.appendChild(box);
      return;
    }

    var els = document.querySelectorAll('.header__cart-count-number');
    Array.prototype.forEach.call(els, function (el) { el.textContent = count; });
  }

  /* ------------------------------------------------------------------
     加購的共用邏輯（click 與 submit 兩條路都呼叫它）
     2026-10-06：按鈕改成「真表單 + JS 攔截」的漸進增強。
       - 有 JS：click / 表單 submit 都會被攔下來走 AJAX（不跳頁、有綠回饋）
       - 沒 JS（lgw-atc.js 掉檔）：攔截不存在，瀏覽器原生 POST /cart/add → 商品照樣進購物車
     ------------------------------------------------------------------ */
  function handleAdd(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    if (btn.dataset.lgwBusy === '1') return;

    btn.dataset.lgwBusy = '1';
    var original = currentLabel(btn);
    setLabel(btn, ADDING_TEXT);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateHeaderCartCount(cart.item_count);
        }

        /* ── 修 2026-10-06 客戶報的 bug：加入購物車後點購物車，抽屜顯示「您的購物車是空的」──
           原因：主題的購物車抽屜是「頁面載入當下」由伺服器渲染好的 HTML（那時購物車是空的）；
                 主題自己的加購流程會用 Section Rendering API 重新渲染抽屜，而我們的
                 /cart/add.js 少了這一步 → 抽屜停留在舊的「空」狀態。
                 症狀：購物車其實有貨（抽屜上的金額也對），但商品清單說沒有商品。
           解法：沿用主題自己的機制。assets/cart-drawer.js 有
                 document.addEventListener('dispatch:cart-drawer:refresh', this.refreshHandler)
                 refresh() 會自己 fetch(`?sections=…`) 再用 renderContents() 把抽屜換成正確內容。
                 我們不必自己實作 section 渲染，也不會跟主題的實作打架。 */
        try {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        } catch (e) { /* 主題沒有抽屜時忽略 */ }

        /* ── 保險網（2026-10-06 加）──
           客戶回報「iPad 和電腦加了看不到，手機正常」，但我們用 iPad（desktop 佈局＋觸控）、
           桌面、以及「非空車再加一件」三種情境都**重現不出來**（全部 PASS）。
           既然重現不了，就不再猜原因，改成「加完自己驗一次、不對就自己修」：
             1.5 秒後若抽屜還寫著「空的」，但 /cart.js 其實有貨 → 用主題自己的
             renderContents() 重畫一次（帶 cache-bust，繞開主題 refresh() 的分支與任何快取）。
           主題正常時這條永遠不會觸發（抽屜已經對了就 return），所以零副作用。 */
        setTimeout(function () {
          var d = document.querySelector('cart-drawer');
          if (!d || typeof d.renderContents !== 'function') return;

          var txt = d.textContent || '';
          if (!/購物車是空的|購物車沒有項目|cart is empty|尚無商品/i.test(txt)) return; // 已經對了

          fetch('/cart.js', { cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cartNow) {
              if (!cartNow || !cartNow.item_count) return; // 真的空車，不用管
              var sec = d.closest('.shopify-section');
              var ids = ['cart-icon-bubble'];
              if (sec) ids.unshift(sec.id.replace('shopify-section-', ''));
              return fetch('/?sections=' + encodeURIComponent(ids.join(',')) + '&_lgw=' + Date.now(),
                           { cache: 'no-store' })
                .then(function (r) { return r.json(); })
                .then(function (sections) { d.renderContents({ sections: sections }, false); });
            })
            .catch(function () { /* 保險網失敗就算了，不要影響加購流程 */ });
        }, 1500);

        btn.classList.add('is-added');
        setLabel(btn, ADDED_TEXT);
        setTimeout(function () {
          btn.classList.remove('is-added');
          setLabel(btn, original);
          btn.dataset.lgwBusy = '0';
        }, 2000);
      })
      .catch(function () {
        setLabel(btn, FAIL_TEXT);
        setTimeout(function () {
          setLabel(btn, original);
          btn.dataset.lgwBusy = '0';
        }, 2500);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-lgw-atc]') : null;
    if (!btn) return;

    // 有 JS 時不要讓表單真的送出（否則會跳頁）；改走 AJAX
    e.preventDefault();
    handleAdd(btn);
  });

  /* 鍵盤 Enter 送出表單時（沒有 click 事件）也要攔下來走 AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-lgw-atc-form]') : null;
    if (!form) return;

    e.preventDefault();
    var btn = form.querySelector('[data-lgw-atc]');
    if (btn) handleAdd(btn);
  });

  /* ------------------------------------------------------------------
     「售罄」點一下閃紅（與樂誠店一致）
     它本來就加不了購物車，但客人還是會去按；給明確回饋比沒反應好。
     ------------------------------------------------------------------ */
  var SOLD_FLASH_MS = 1300;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.lgw-soldout-btn') : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.dataset.lgwSoldFlash === '1') return;

    btn.dataset.lgwSoldFlash = '1';
    btn.classList.add('is-tapped');
    setTimeout(function () {
      btn.classList.remove('is-tapped');
      btn.dataset.lgwSoldFlash = '0';
    }, SOLD_FLASH_MS);
  });
})();
